import {toast, ToastContainer} from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "./sidebar";
import SupportElement from "./elements/support_element/supportElement";
import './panel.scss';
import {useState} from 'react';
import Physical from "./physical/physical";
import {useNavigate} from "react-router-dom";
import Subscription from "./subscription/subscription";
import UserMeal from "./user_meal/userMeal";
import AuthService from "../../services/auth.service";
import Dashboards from "./dashboard/dashboard";
import TopHeader from "./layouts/top_header/TopHeader";

const APP_URL = process.env.APP_URL;

const Panel = (props) => {
    const user = AuthService.getUser();
    const supportElements = AuthService.getSupportElements();
    const [content, setContent] = useState(null);
    const {component} = props;
    return (

        <div className="container panel-route">
            <div className="panel-container">
                <TopHeader/>
                <Sidebar setContent={setContent} component={component}/>

                <div className="content-container">
                    {content ? content : (user.subscription ? <Dashboards setContent={setContent}/> : <Physical/>)}
                </div>

                {/*<SupportElement supportElements={supportElements?supportElements:''}/>*/}
            </div>

            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </div>
    );
}

export default Panel;